import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../core/services/config/config.service';
import { UtilityService } from '../../core/services/utility/utility.service';
import { MedicalRecordNotification } from '../models/medical-record-notification';

@Injectable({
  providedIn: 'root',
})
export class MedicalRecordNotificationsService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  endpoint = `${this.config.patientApiUrl}/v1/PatientPortal/MedicalRecordNotifications`;

  getMedicalRecordNotifications(patientId: number): Observable<MedicalRecordNotification> {
    const url = `${this.endpoint}?patientId=${patientId}`;
    return this.utilityService.getRequest<MedicalRecordNotification>(url);
  }
}
